import bannerImg from './banners/woman-helping-man-gym.jpg';

const leadTreinoOnline = (t) => ({
    id: 'lead-treino-online',
    title: t('templates.items.leadTreinoOnline.title'),
    description: t('templates.items.leadTreinoOnline.description'),
    indicatedFor: t('templates.audiences.personalTrainers'),
    stepsCount: 1,
    questionsSummary: [
        t('templates.items.leadTreinoOnline.summary.nameAndContact'),
        t('templates.items.leadTreinoOnline.summary.mainGoal'),
        t('templates.items.leadTreinoOnline.summary.availability'),
        t('templates.items.leadTreinoOnline.summary.howFound'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.leadTreinoOnline.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.leadTreinoOnline.form.start.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.leadTreinoOnline.form.start.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.leadTreinoOnline.form.start.name.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'email',
                        label: t('templates.items.leadTreinoOnline.form.start.email.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'phone',
                        label: t('templates.items.leadTreinoOnline.form.start.whatsapp.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'choices',
                        label: t('templates.items.leadTreinoOnline.form.start.goal.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.leadTreinoOnline.form.start.goal.options.loseWeight') },
                                { id: 'opt-2', label: t('templates.items.leadTreinoOnline.form.start.goal.options.gainMuscle') },
                                { id: 'opt-3', label: t('templates.items.leadTreinoOnline.form.start.goal.options.conditioning') },
                                { id: 'opt-4', label: t('templates.items.leadTreinoOnline.form.start.goal.options.wellbeing') },
                            ],
                        },
                    },
                    {
                        order: 5,
                        type: 'choices',
                        label: t('templates.items.leadTreinoOnline.form.start.howFound.label'),
                        description: null,
                        required: false,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.leadTreinoOnline.form.start.howFound.options.instagram') },
                                { id: 'opt-2', label: t('templates.items.leadTreinoOnline.form.start.howFound.options.referral') },
                                { id: 'opt-3', label: t('templates.items.leadTreinoOnline.form.start.howFound.options.youtube') },
                                { id: 'opt-4', label: t('templates.items.leadTreinoOnline.form.start.howFound.options.tiktok') },
                                { id: 'opt-5', label: t('templates.items.leadTreinoOnline.form.start.howFound.options.other') },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default leadTreinoOnline;
